module.exports = __webpack_public_path__ + "6bc48cec840977cf8a4412ff26e3b251.glb";